import React from 'react';

import {useAccordion} from 'brandComponents/Accordion/AccordionContext';
import Icon from 'brandComponents/Icon';

const AccordionHeaderIcon = ({expandIcon = 'plus-circle', collapseIcon = 'minus-circle', width = 20, height = 20}) => {
	const {isOpen} = useAccordion();

	return <Icon name={isOpen ? collapseIcon : expandIcon} width={width} height={height} />;
};

export default AccordionHeaderIcon;
